import { useApi } from '@api/ApiProvider'
import { useI18n } from '@i18n/I18nProvider'
import { useQuery } from '@tanstack/react-query'

// Misma clave que el mapa (['stages', idioma]): si ya se abrió el mapa, la lista sale de caché.
export const useStages = () => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: ['stages', locale], queryFn: () => api.stages(locale) })
}

export const stageQueryKey = (id: string, locale: string) => ['stage', id, locale] as const

export const useStage = (id: string) => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: stageQueryKey(id, locale), queryFn: () => api.stage(id, locale) })
}
